export default __webpack_public_path__ + "static/media/logo-mark.a38a7a3e.svg";